export class OtherFinance {
  sOtherFinancing: number;
  sQualifyRationsFlag: boolean;
  sNotesRate: number;
  sQualifyRate: number;
  sTermDue: number;
  sExistingLienFlag: boolean;
  sHELOCFlag: boolean;
  sSourceType: string;
  sPaymentDeferredFirstFiveYearsFlag: boolean;
  sCreditorName: string;
  sBelowMarketSubordinateFinancing: boolean;
}
